import {Box, Divider, Stack, Typography} from '@mui/material';
import {LenderProfile} from '@trnsact/trnsact-shared-types';
import {S3_BUCKET_NAME} from "../../../../config";

export const LenderInfo = ({
  lenderProfile,
  commonClasses,
}: {
  lenderProfile: LenderProfile;
  commonClasses: any,
}) => {

  return <Box className={commonClasses.lenderDealerContactInfoBlock}>
    <Stack className={commonClasses.infoRows} spacing={1} divider={<Divider />}>
      <Box className={commonClasses.infoRow}>
        <Typography fontWeight={500}>Financing Source</Typography>
        <Typography fontWeight={500}>{lenderProfile.name}</Typography>
      </Box>
    </Stack>

    {lenderProfile.logo && <Box className={commonClasses.logoContainer}>
      <img
        style={{ maxWidth: '100%' }}
        src={`https://${S3_BUCKET_NAME}.s3-us-west-2.amazonaws.com/${lenderProfile.logo}`}
        alt="Lender Logo"
      />
    </Box>}
  </Box>
};
